import { Vector2 } from 'three';
import { logger } from '@/modules/common/logging/logger';
import { ConnectionDirections } from '@/modules/contextMenu/types';
import { IContextMenuService } from './IContextMenuService';

export class ContextMenuServiceLogDecorator implements IContextMenuService {
  private decoree: IContextMenuService;

  constructor(decoree: IContextMenuService) {
    this.decoree = decoree;
  }

  setPosition(position: Vector2 | null): void {
    const start = this.logStart();
    this.decoree.setPosition(position);
    this.logEnd('setPosition', start);
  }

  setContext(context: 'AREA' | 'CONNECTION' | 'CONTROL_POINT' | null): void {
    const start = this.logStart();
    this.decoree.setContext(context);
    this.logEnd('setContext', start);
  }

  setRelatedComponentId(id: string | undefined): void {
    const start = this.logStart();
    this.decoree.setRelatedComponentId(id);
    this.logEnd('setRelatedComponentId', start);
  }

  setRelatedControlPoint(
    controlPoint: { elementId: string; pointIndex: number } | undefined,
  ): void {
    const start = this.logStart();
    this.decoree.setRelatedControlPoint(controlPoint);
    this.logEnd('setRelatedControlPoint', start);
  }

  setRelatedAreaIds(ids: string[]): void {
    const start = this.logStart();
    this.decoree.setRelatedAreaIds(ids);
    this.logEnd('setRelatedAreaIds', start);
  }

  setActiveConnectionTab(tab: ConnectionDirections | undefined): void {
    const start = this.logStart();
    this.decoree.setActiveConnectionTab(tab);
    this.logEnd('setActiveConnectionTab', start);
  }

  reset(): void {
    const start = this.logStart();
    this.decoree.reset();
    this.logEnd('reset', start);
  }

  private logStart(): number {
    return performance.now();
  }

  private logEnd(methodName: string, startTime: number): void {
    const duration = performance.now() - startTime;
    logger.debug(`ContextMenuService.${methodName} completed in ${duration.toFixed(2)}ms`);
  }
}
